import { render, staticRenderFns } from "./IconListIframe.vue?vue&type=template&id=b5f7c19a&"
import script from "./IconListIframe.vue?vue&type=script&lang=ts&"
export * from "./IconListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports